import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "http://localhost:5002";
const LANDING_URL = process.env.REACT_APP_LANDING_URL || "http://localhost:3000";

export default function Login() {
  return (
    <div className="login-page">
      <div className="login-bg"></div>

      <nav className="login-nav">
        <a href={LANDING_URL} className="login-logo">
          🌱 <span style={{ color: "var(--dark)" }}>Sprout</span>
        </a>
      </nav>

      <div className="login-container">
        <div className="badge">🌱 Personal finance, simplified</div>

        <h1 className="login-title">Welcome back</h1>
        <p className="login-subtitle">Sign in to continue tracking your spending</p>

        <div className="login-card">
          <a href={`${BACKEND}/auth/google`} className="login-google-btn">
            <img
              src="https://developers.google.com/identity/images/g-logo.png"
              alt="Google"
              className="login-icon"
            />
            <span>Continue with Google</span>
          </a>

          <div className="login-divider">
            <div className="login-divider-line"></div>
            <span className="login-divider-text">or</span>
            <div className="login-divider-line"></div>
          </div>

          <a href={`${BACKEND}/auth/github`} className="login-github-btn">
            <img
              src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
              alt="GitHub"
              className="login-icon"
              style={{ filter: "invert(1)" }}
            />
            <span>Continue with GitHub</span>
          </a>

          <p className="login-terms">
            By signing in you agree to our{" "}
            <a href="/">Terms of Service</a> and{" "}
            <a href="/">Privacy Policy</a>
          </p>
        </div>

        <p className="login-back">
          <a href={LANDING_URL}>← Back to home</a>
        </p>
      </div>
    </div>
  );
}